let language = {
    "A109B001": "Store does not exist ",
    "A109B002": "Store does not exist ",

    "A109B003": "Your partner account is not actived yet, please activate your partner account first.",
    "A109B004": "Your partner account is not actived yet, please login to your mail-box, and find registration e-mail, and then activate your partner account first.",

    "A109B005": "Email not activated",
    "A109B006": "Email not activated",

};

export { language }